import React from "react";

const ResourceMetaSEO = ({
  showMeta,
  toggleShowMeta,
  generateMeta,
  resource,
  register,
  watchTitle,
  watchDescription,
  checkLength
}) => (
  <div className="meta">
    <div className="d-flex justify-content-between align-items-center bg-light mb-4 py-2">
      <strong className="px-3">Meta SEO</strong>
      <div>
        <button
          type="button"
          className="btn btn-sm"
          onClick={() => {
            generateMeta(resource._id);
          }}
        >
          <i className="bi bi-asterisk text-muted"></i>
        </button>
        <button
          type="button"
          onClick={() => toggleShowMeta(!showMeta)}
          className="btn btn-link px-0 mx-4"
        >
          {showMeta ? "Hide" : "Show"}
        </button>
      </div>
    </div>
    <div className={`meta-fields ${showMeta ? "d-block" : "d-none"}`}>
      <div className="mb-3">
        <label htmlFor="tags" className="form-label">
          Meta title
        </label>
        <input
          className="form-control"
          {...register("meta_title")}
        />
        <div className="text-muted text-sm my-2">
          {"Title should be 30 to 65 characters"}
          {watchTitle && (
            <div
              className="d-inline"
              dangerouslySetInnerHTML={{
                __html: checkLength(watchTitle, 30, 65)
              }}
            />
          )}
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="description" className="form-label">
          Meta Descrtiption
        </label>
        <textarea
          className="form-control"
          {...register("meta_description")}
          rows={4}
        />
        <div className="text-muted text-sm my-2">
          {"Description should be 120 to 320 characters"}
          {watchDescription && (
            <div
              className="d-inline"
              dangerouslySetInnerHTML={{
                __html: checkLength(watchDescription, 120, 320)
              }}
            />
          )}
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="tags" className="form-label">
          Meta keywords
        </label>
        <input
          className="form-control"
          {...register("meta_keywords")}
        />
        <span className="text-muted text-sm py-2">
          {"The keyword should be placed at the begining of title and description"}
        </span>
      </div>
      <div className="mb-3">
        <label htmlFor="tags" className="form-label">
          Canonical Url
        </label>
        <input
          className="form-control"
          {...register("meta_canonicalURL")}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="tags" className="form-label">
          Redirect Url
        </label>
        <input
          className="form-control"
          {...register("meta_redirectURL")}
        />
      </div>
    </div>
  </div>
);

export default ResourceMetaSEO;
